import React, { useState } from 'react'
import { DescriptionsContext } from '../contexts/Descriptions.context'

export const DescriptionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const fetchData = async (url: string, options?: any) => {
    setLoading(true)
    setError(null)

    try {
      const response = await fetch(url, options)
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`)
      }
      const result = await response.json()
      setData(result)
    } catch (err: any) {
      setError(err.message || 'Unknown error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <DescriptionsContext.Provider value={{ data, loading, error, fetchData }}>{children}</DescriptionsContext.Provider>
  )
}
